const songs = [{

    id: 4,
    title: "Dont Matter",
    src: require("../assets/music/Akon - Dont Matter.mp3"),
    artist: "Akon",
    date_modified: "3/09/2011",
    favourite: false,
    duration: "04:05",
    img: require("../assets/img/9.jpeg"),
  },
  {
    id: 5,
    title: "All Of Me",
    src: require("../assets/music/All Of Me.mp3"),
    artist: "John Legend",
    date_modified: "23/01/2016",
    favourite: false,
    duration: "04:29",
    img: require("../assets/img/10.jpeg"),
  },
  {
    id: 6,
    title: "Aza",
    src: require("../assets/music/Aza - Dmw.mp3"),
    artist: "Davido Ft Duncan Mighty",
    date_modified: "28/08/2016",
    favourite: false,
    duration: "03:45",
    img: require("../assets/img/15.jpeg"),
  },
  {
    id: 8,
    title: "Beneath Your Beautiful",
    src: require("../assets/music/Beneath Your Beautiful -Dr Sid Ft Tiwa Savage.mp3"),
    artist: "Dr Sid Ft Tiwa Savage",
    date_modified: "10/09/2014",
    favourite: false,
    duration: "04:28",
    img: require("../assets/img/24.jpg"),
  },

  {
    id: 10,
    title: "Level Up",
    src: require("../assets/music/Ciara - Level Up.mp3"),
    artist: "Ciara",
    date_modified: "27/07/2016",
    favourite: false,
    duration: "03:31",
    img: require("../assets/img/12.jpeg"),
  },

  {
    id: 17,
    title: "Mariah Carey",
    src: require("../assets/music/Ill be there.mp3"),
    artist: "Mariah Carey",
    date_modified: "6/08/2003",
    favourite: false,
    duration: "01:53",
    img: require("../assets/img/3.jpeg"),
  },

  {
    id: 19,
    title: "Halleluya",
    src: require("../assets/music/Johnny Drille  Ft Simi - Halleluya.mp3"),
    artist: "Johnny Drille Ft Simi",
    date_modified: "19/06/2017",
    favourite: false,
    duration: "03:54",
    img: require("../assets/img/14.jpeg"),
  },

  {
    id: 22,
    title: "Freaky Friday",
    src: require("../assets/music/Lil Dicky - Freaky Friday ft. Chris Brown.mp3"),
    artist: "Chris Brown Ft Lil Dicky",
    date_modified: "18/12/2018",
    favourite: false,
    duration: "03:35",
    img: require("../assets/img/11.jpeg"),
  },
  {
    id: 24,
    title: "Teach the World",
    src: require("../assets/music/Lucky Dube-Teach the World.mp3"),
    artist: "Lucky Dube",
    date_modified: "13/07/2011",
    favourite: false,
    duration: "04:44",
    img: require("../assets/img/17.jpeg"),
  },

  {
    id: 26,
    title: "Particula",
    src: require("../assets/music/Major Lazer - Particula (feat. Nasty C, Ice Prince, Patoranking & Jidenna).mp3"),
    artist: "Major Lazer Ft Nasty C, Ice Prince, Patoranking, Jidenna",
    date_modified: "13/02/2018",
    favourite: false,
    duration: "03:24",
    img: require("../assets/img/3.jpeg"),
  },

  {
    id: 29,
    title: "Speechless",
    src: require("../assets/music/Michael Jackson - Speechless.mp3"),
    artist: "Michael Jackson",
    date_modified: "6/09/2006",
    favourite: false,
    duration: "03:20",
    img: require("../assets/img/5.jpeg"),
  },


  {
    id: 33,
    title: "Bring it on",
    src: require("../assets/music/P-Square ft Dave Scott_–Bring it on.mp3"),
    artist: "P-Square Ft Dave Scott",
    date_modified: "18/03/2017",
    favourite: false,
    duration: "03:59",
    img: require("../assets/img/8.jpeg"),
  },
  {
    id: 35,
    title: "Perfect",
    src: require("../assets/music/Perfect - Ed Sheeran.mp3"),
    artist: "Ed Sheeran",
    date_modified: "31/09/2016",
    favourite: false,
    duration: "04:28",
    img: require("../assets/img/4.jpeg"),
  },

  {
    id: 39,
    title: "Right Now (Remix)",
    src: require("../assets/music/Seyi Shay - Right Now (Remix) ft. Iyanya & Banky W.mp3"),
    artist: "Seyi Shay Ft Iyanya, Banky W",
    date_modified: "12/07/2018",
    favourite: false,
    duration: "03:35",
    img: require("../assets/img/18.jpeg"),
  },
  {
    id: 40,
    title: "Angel",
    src: require("../assets/music/Shaggy - Angel ft. Rayvon.mp3"),
    artist: "Shaggy Ft Rayvon",
    date_modified: "24/08/2015",
    favourite: false,
    duration: "03:56",
    img: require("../assets/img/10.jpeg"),
  },
];

export default {
  songs() {
    return songs;
  },
};